import React, { useState } from 'react';
import { Box, Typography, IconButton, Grid, Divider } from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';

type DealerInfoType = {
  title: string;
  row: any;
  updateHeight: Function;
};
const DealerInfo = ({ title, row, updateHeight }: DealerInfoType) => {
  const [expanded, setExpanded] = useState(true);
  const handleToggleExpanded = () => {
    updateHeight();
    setExpanded(!expanded);
  };

  return (
    <Box pb={1} width="100%">
      <Divider />
      <Box pt={1} display="flex" alignItems="center">
        <Box pr={1}>
          <Typography variant="h6">{title}</Typography>
        </Box>
        <IconButton
          onClick={handleToggleExpanded}
          aria-label="expand"
          style={{ width: '1rem', height: '1rem', marginRight: '1rem' }}
          size="large"
        >
          {expanded ? <ExpandMore /> : <ChevronRight />}
        </IconButton>
      </Box>
      {expanded && (
        <Grid container spacing={3} p={2}>
          <Grid item xs={2}>
            <Typography>File ID</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.id}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>User ID</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.userId || row?.vimsSftpUserId}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>File Type</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.fileTypeId}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography> File Extension</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.extension}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>File Name</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.fileTypeName}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>File Size</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.fileSize}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>Dealer Code</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.dealerCode}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>Customer Code</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.customerCode}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>Gateway Receipt TS</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.gatewayReceiptTime}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>Sent to Endpoint</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.endpointOrCommandTs}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>Error Description</Typography>
          </Grid>
          <Grid item xs={4}>
            {row &&
              Array.isArray(row.errors) &&
              row.errors.map((errorItem: any) => <Typography>{errorItem.message}</Typography>)}
            {row && !Array.isArray(row.errors) && <Typography>{row.errors}</Typography>}
          </Grid>
          <Grid item xs={2}>
            <Typography>Parent Compressed File Name</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>{row?.parentCompressedFileName}</Typography>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default DealerInfo;
